import React, { useEffect, useState } from 'react';
import {
	Container,
	Card,
	CardBody,
	CardHeader,
	Button,
	Row,
	Col,
} from 'reactstrap';
import {
	masterServiceBaseUrl,
	concessionServiceBaseUrl,
	getAPI,
	failureToast,
} from 'services/http';
import CustomLoader from '../../../../common/commonComponents/Loader/loader';
import { Accordion } from '../../../../common/commonComponents/Accordion/accordion';
import {
	fetchAllData,
	fetchDetails,
	getDispValForReactSelectByOneID,
} from '../../../../common/utils/methods/commonMethods/utilityMethod';
import { BsFillForwardFill } from 'react-icons/bs';
import { updateData } from '../../../../../../../redux';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CommonHeader from '../commonHeader';
import AddCourseForSecurity from './addCourseForSecurity';
import './addCourseForSecurity.scss';

const AddCourseSecurity = (props) => {
	const { id } = props.match.params;
	const dispatch = useDispatch();
	let history = useHistory();
	const { action, isNew = true, formId, isViewOnly = false } = props;
	const [apiLoader, setApiLoader] = useState(false);
	const [BUAndSecurityData, setBUAndSecurityData] = useState([]);
	const [BUAndSecurityList, setBUAndSecurityList] = useState([]);
	const [courseData, setCourseData] = useState([]);
	const [addCourse, setAddCourse] = useState([]);

	// let id = 39;

	useEffect(() => {
		getBUAndSecurityData();
	}, [id]);

	useEffect(() => {
		fetchDetails(
			masterServiceBaseUrl + '/courseCatalogMapping/getActiveCourseCatalog',
			setCourseData,
			'course',
			'courseDetails'
		);
		fetchDetails(
			masterServiceBaseUrl + '/term/getAllActiveTerm',
			setBUAndSecurityList,
			'term',
			'reactSelect'
		);
	}, []);

	const getBUAndSecurityData = async () => {
		try {
			setApiLoader(true);
			getAPI(
				`${concessionServiceBaseUrl}/buAndCourseSecurity/${id}`,
				(data) => {
					setBUAndSecurityData(data.data);
					setApiLoader(false);
				},
				(data) => {
					failureToast(data['message']);
					setApiLoader(false);
				}
			);
		} catch (e) {
			console.log('Error', e);
		}
	};

	const headerData = [
		{
			label: 'Business Group',
			value: props.headerData && props.headerData.businessGroup,
		},
		{
			label: 'Company Code',
			value: props.headerData && props.headerData.companyCode,
		},
		{
			label: 'Academic Career',
			value: props.headerData && props.headerData.academicCareer,
		},
		{
			label: 'Academic Group',
			value: props.headerData && props.headerData.academicGroup,
		},
		{
			label: 'Category CD - Description',
			value: `${props.headerData && props.headerData.categoryCode} - ${
				props.headerData && props.headerData.description
			}`,
		},
		{
			label: 'Sub Category CD - Description',
			value: `${props.headerData && props.headerData.subCategoryCode} - ${
				props.headerData && props.headerData.subCategoryDesc
			}`,
		},
		{
			label: 'Sub Sub Category - Description',
			value: `${
				props.headerData && props.headerData.subSubCategoryDispValue
			} - ${props.headerData && props.headerData.subSubCategoryShortDesc}`,
		},
		{
			label: 'Term',
			value: `${
				BUAndSecurityData &&
				BUAndSecurityData.termId &&
				getDispValForReactSelectByOneID(
					BUAndSecurityData.termId,
					'DispValue',
					BUAndSecurityList
				)
			}`,
		},
	];

	useEffect(() => {
		if (BUAndSecurityData && BUAndSecurityData.termId && BUAndSecurityList) {
			dispatch(
				updateData({
					...props.headerData,
					term: getDispValForReactSelectByOneID(
						BUAndSecurityData.termId,
						'DispValue',
						BUAndSecurityList
					),
				})
			);
		}
	}, [BUAndSecurityData, BUAndSecurityData.termId, BUAndSecurityList]);
	return (
		<>
			<Container className="mt-4" fluid>
				<Card>
					<CardHeader>
						<h2 className="mb-0 floatLeft">
							Scholarship Master &nbsp;
							{<BsFillForwardFill style={{ fontSize: '30px' }} />}&nbsp; Add Sub
							Category &nbsp;
							{<BsFillForwardFill style={{ fontSize: '30px' }} />}&nbsp; Add Sub
							Sub Category &nbsp;
							{<BsFillForwardFill style={{ fontSize: '30px' }} />}&nbsp;{' '}
							<span
								onClick={() => props.history.goBack()}
								style={{ cursor: 'pointer', color: '#11CDEF' }}
							>
								Setup Course Security
							</span>
							&nbsp;
							{<BsFillForwardFill style={{ fontSize: '30px' }} />}&nbsp; Add
							Course
						</h2>
					</CardHeader>
				</Card>
				{apiLoader ? (
					<div
						className="mx-auto text-center py-5 my-5"
						style={{ height: '100vh' }}
					>
						<CustomLoader
							apiLoader={apiLoader}
							loaderHeight={'200px'}
							loaderWidth={'100%'}
						/>
					</div>
				) : (
					<div>
						<Card>
							<CardBody>
								<CommonHeader
									headerData={headerData}
									lastUpdatedDate={
										BUAndSecurityData && BUAndSecurityData['updatedOn']
									}
									countLabel={'Total Active Courses '}
									countValue={
										(BUAndSecurityData && BUAndSecurityData['courseCount']) ||
										'00'
									}
								/>
							</CardBody>
						</Card>
						<Card>
							<CardBody>
								<AddCourseForSecurity
									buAndCourseSecurityId={id}
									course={courseData}
									addCourse={addCourse}
									setAddCourse={setAddCourse}
									getBUAndSecurityData={getBUAndSecurityData}
								/>
							</CardBody>
						</Card>
					</div>
				)}
			</Container>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		headerData: state.globalData.data,
	};
};

export default connect(mapStateToProps)(AddCourseSecurity);
